(function initMarbleKeyInputVisibilityToggle() {
    function updateToggleIcon(toggleBtn, isHidden) {
        const iconEl = toggleBtn.querySelector('i');
        if (!iconEl) return;
        iconEl.classList.toggle('icon-show-annotation', isHidden);
        iconEl.classList.toggle('icon-hidden-annotation', !isHidden);
    }

    function bindKeyInputToggle(toggleBtn) {
        const targetInputId = toggleBtn.getAttribute('data-target-input');
        if (!targetInputId) return;

        const inputEl = document.getElementById(targetInputId);
        if (!inputEl) return;

        const isHidden = inputEl.type !== 'text';
        updateToggleIcon(toggleBtn, isHidden);

        toggleBtn.addEventListener('click', () => {
            const nextIsHidden = inputEl.type === 'text';
            inputEl.type = nextIsHidden ? 'password' : 'text';
            updateToggleIcon(toggleBtn, nextIsHidden);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('.marble-key-toggle-btn').forEach(bindKeyInputToggle);
        });
        return;
    }

    document.querySelectorAll('.marble-key-toggle-btn').forEach(bindKeyInputToggle);
})();
